import { useMutation } from 'query';
import { useEhrPortalRedirect } from '../../hooks';

type Variables = {
  referrer: string;
};

export const useEhrPortalRedirectMutation = () => {
  const ehrPortalRedirect = useEhrPortalRedirect();

  return useMutation<undefined, Variables>({
    async mutationFn({ referrer }: Variables) {
      await ehrPortalRedirect(referrer);
      return undefined;
    },
  });
};
